import React, { useEffect, useMemo, useState } from 'react';
import { ChatControl } from '../newControlManager/themes/bootstrap/chat';
import { useUserContext } from './contextProviders/userContext';
import { OpenChatButton } from './OpenChatButton';
import '../../assets/css/revised_css/components/controlManagerThemes/bootstrap/markdown.css'
export function ChatWrapper({ children, textSourceRef, fieldName, reportId, blockId, blockName,
  objectMetadata, chatProps = {}, onChatClose, onChange }) {
  const { user } = useUserContext();
  const [isOpen, setIsOpen] = useState(false);
  const [initialInput, setInitialInput] = useState('');
  const [forceInputUpdate, setForceInputUpdate] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const metadata = useMemo(() => objectMetadata || { _id: reportId, blockId: blockId, blockName: blockName }, [objectMetadata, reportId, blockId, blockName]);

  // Load chat history when sidebar opens
  useEffect(() => {
    if (!isOpen || !fieldName || !metadata?._id) return;
    let beta = '';
    let abort = false;
    async function loadChatHistory() {
      try {
        let api = `${process.env.REACT_APP_PROTOCOL}:${process.env.REACT_APP_APP_URL}${beta}/chat/chat/history`;
        const res = await fetch(`${api}?fieldId=${encodeURIComponent(fieldName)}&reportId=${encodeURIComponent(metadata._id)}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${user.token}`,
            'Content-Type': 'application/json'
          }
        });
        if (abort) return;
        const data = await res.json();
        setChatHistory(Array.isArray(data) ? data : []);
      } catch (e) {
        if (!abort) setChatHistory([]);
      }
    }
    loadChatHistory();
    return () => { abort = true; };
  }, [isOpen, fieldName, metadata, user]);

  // Do not lock body scroll; backdrop is purely visual
  // (Intentionally left blank after decision to keep page interactive)
  useEffect(() => {}, [isOpen]);

  const handleOpenChat = (selectedText) => {
    const newInput = selectedText ? 'You said to revise this:\n' + selectedText : '';
    setInitialInput(newInput);
    
    if (!isOpen) {
      setIsOpen(true);
    } else {
      // If chat is already open, update the input in ChatControl
      // We'll pass this as a prop to trigger input update
      setForceInputUpdate(newInput);
    }
  };

  const handleCloseChat = () => {
    // Remove yellow background highlight when closing chat
    if (textSourceRef?.current) {
      const el = textSourceRef.current;
      if (typeof el.getEditor === 'function') {
        // For ReactQuill, remove all yellow backgrounds
        const editor = el.getEditor();
        const contents = editor.getContents();
        let currentIndex = 0;
        contents.ops.forEach(op => {
          if (op.attributes && op.attributes.bg === 'bg-yellow') {
            editor.formatText(currentIndex, op.insert.length, { bg: null });
          }
          currentIndex += op.insert.length;
        });
      }

      setForceInputUpdate();
    }
    
    setIsOpen(false);
    // Trigger onChatClose callback after state update
    setTimeout(() => {
      onChatClose?.();
    }, 0);
  };

  return (
    <div>
    {isOpen && <div className="chat-backdrop" />}
    <div className={(isOpen ? 'chat-wrapper-active' : '') + ' chat-wrapper'} style={{ position: 'relative' }}>
     
      <div style={{ position: 'relative' }} className="joy-like-markdown">
        {children}
        <OpenChatButton textSourceRef={textSourceRef} fieldName={fieldName} onOpenChat={handleOpenChat} onChange={onChange} />
      </div>
      {isOpen && (
        <div style={{ marginTop: 12 }}>
          <ChatControl
            idx={0}
            name="chat"
            objectMetadata={metadata}
            initialInput={initialInput}
            forceInputUpdate={forceInputUpdate}
            fieldId={fieldName}
            sidebarOpen={isOpen}
            setSidebarOpen={setIsOpen}
            initialMessages={chatHistory}
            textSourceRef={textSourceRef}
            onChange={onChange}
            onClose={handleCloseChat}
            {...chatProps}
          />
        </div>
      )}
    </div>
    </div>
  );
} 